import VerticalBar from '@/charts/VerticalBar';
import * as Styles from './NewByOwnerChart.styles';
import ChartEmptyState from '../ChartEmptyState';
import ChartHeader from '../ChartHeader';
import Loading from '../general/Loading';

type NewByOwnerChartComponentProps = {
  isLoading: boolean;
  periodOptions: any[];
  data: any[];
  onSelectFilter: (value: string) => void;
};

const NewByOwnerChartComponent = function ({
  isLoading,
  periodOptions,
  data,
  onSelectFilter,
}: NewByOwnerChartComponentProps): JSX.Element {
  const style = {
    width: '414px',
    height: '428px',
  };

  return (
    <Styles.CustomChartCard data-testid="new-by-owner-chart">
      <Styles.FullHeightContainer>
        <ChartHeader
          onSelectFilter={onSelectFilter}
          filterOptions={periodOptions}
          title="New by Owner"
          tooltipMessage="This chart displays the total number of new candidates created on the selected date, grouped by their owners"
        />
        {isLoading ? (
          <div style={style}>
            <Loading size={25} sx={{ marginTop: 9 }} />
          </div>
        ) : (
          <div>{data.length > 0 && <VerticalBar data={data} />}</div>
        )}
        <Styles.EmptyStateContainer>
          {data.length === 0 && (
            <ChartEmptyState
              title="Your search didn’t match any result"
              subTitle="Try to choose different options."
            />
          )}
        </Styles.EmptyStateContainer>
      </Styles.FullHeightContainer>
    </Styles.CustomChartCard>
  );
};

export default NewByOwnerChartComponent;
